// extracted by mini-css-extract-plugin
export default {"list":"Claims-list_Kdv7v","listItem":"Claims-listItem_JqaVa","justify":"Claims-justify_DDZJU"};